import { Injectable } from "@angular/core";
import {
    Router
    ,Route
    ,CanActivate
    ,CanActivateChild
    ,CanLoad
    ,ActivatedRouteSnapshot
    ,RouterStateSnapshot
    ,NavigationExtras
} from "@angular/router";

import { FvmsApiAuthService } from "./fvms.api.auth.service";

@Injectable({
    providedIn: "root"
})
export class FvmsApiAuthGuard implements CanActivate,CanActivateChild,CanLoad {
    constructor(
        private router:Router
        ,private fvmsApiAuthService:FvmsApiAuthService
    ) {

    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let url:string = state.url;
        return this.checkLogin(url);
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(route,state);
    }

    canLoad(route: Route): boolean {
        let url = `/${route.path}`;
        return this.checkLogin(url);
    }

    checkLogin(url:string):boolean{
        if(this.fvmsApiAuthService.getLoginUserInfo()){
            return true;
        }

        let navigationExtras: NavigationExtras = {
            queryParams: { "returnUrl": url }
            ,fragment: "anchor"
        };

        this.router.navigate(["/fvms/auth/login/main"],navigationExtras);
        return false;
    }
}
